import type { BillingAddress, PaymentMethod } from '@/types/payment'
import { APPLICANT_CONTENT } from '@/features/applicant/constants/applicantContent'

export function validatePaymentFormFields(params: {
  paymentMethod: PaymentMethod
  firstName: string
  lastName: string
  cardNumber: string
  expiryMonth: string
  expiryYear: string
  cvv: string
  billingAddress: BillingAddress
}): Record<string, string> {
  const {
    paymentMethod,
    firstName,
    lastName,
    cardNumber,
    expiryMonth,
    expiryYear,
    cvv,
    billingAddress,
  } = params

  const newErrors: Record<string, string> = {}

  if (!firstName.trim()) {
    newErrors.firstName = APPLICANT_CONTENT.errors.fieldRequired.firstName
  }
  if (!lastName.trim()) {
    newErrors.lastName = APPLICANT_CONTENT.errors.fieldRequired.lastName
  }

  if (paymentMethod !== 'CARDCONNECT') {
    return newErrors
  }

  const cardDigits = cardNumber.replace(/\D/g, '')
  if (cardDigits.length < 13 || cardDigits.length > 19) {
    newErrors.cardNumber = APPLICANT_CONTENT.errors.fieldRequired.cardNumber
  }
  if (!expiryMonth) {
    newErrors.expiryMonth = APPLICANT_CONTENT.errors.fieldRequired.month
  }
  if (!expiryYear) {
    newErrors.expiryYear = APPLICANT_CONTENT.errors.fieldRequired.year
  }
  if (cvv.length < 3) {
    newErrors.cvv = APPLICANT_CONTENT.errors.fieldRequired.cvv
  }
  if (!billingAddress.house_no.trim()) {
    newErrors.house_no = APPLICANT_CONTENT.errors.fieldRequired.houseNo
  }
  if (!billingAddress.street.trim()) {
    newErrors.street = APPLICANT_CONTENT.errors.fieldRequired.street
  }
  if (!billingAddress.city.trim()) {
    newErrors.city = APPLICANT_CONTENT.errors.payment.city
  }
  if (!billingAddress.zip_code.trim() || billingAddress.zip_code.length < 5) {
    newErrors.zip_code = APPLICANT_CONTENT.errors.fieldRequired.zipCodeValid
  }

  return newErrors
}
